export default {
  designer: [
    {
      id: 1,
      skills: [
        {
          id: "uiux",
          label: "UI/UX",
          value: 7,
        },
        {
          id: "mobile",
          label: "Mobile",
          value: 7,
        },
        {
          id: "logo",
          label: "Logo Design",
          value: 5,
        },
        {
          id: "sketching",
          label: "Sketching",
          value: 3,
        },
      ],
    },
    {
      id: 2,
      skills: [
        {
          id: "xd",
          label: "XD",
          value: 7,
        },
        {
          id: "figma",
          label: "Figma",
          value: 7,
        },
        {
          id: "illustrator",
          label: "Illustrator",
          value: 6,
        },
        {
          id: "photoshop",
          label: "Photoshop",
          value: 4,
        },
        {
          id: "pencilpaper",
          label: "Pencil & Paper",
          value: 3,
        },
      ],
    },
  ],
  developer: [
    {
      id: 1,
      skills: [
        {
          id: "html5",
          label: "HTML5",
          value: 7,
        },
      ],
    },
    {
      id: 2,
      skills: [
        {
          id: "css3",
          label: "CSS3",
          value: 7,
        },
        {
          id: "sass",
          label: "Sass",
          value: 7,
        },
      ],
    },
    {
      id: 3,
      skills: [
        {
          id: "javascript",
          label: "Javascript",
          value: 8,
        },
        {
          id: "typescript",
          label: "Typescript",
          value: 8,
        },
        {
          id: "vue",
          label: "Vue",
          value: 8,
        },
        {
          id: "react",
          label: "React",
          value: 7,
        },
      ],
    },
    {
      id: 4,
      skills: [
        {
          id: "node",
          label: "Node.js",
          value: 5,
        },
        {
          id: "mongo",
          label: "MongoDB",
          value: 5,
        },
      ],
    },
  ],
};
